// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2Zcvf","dragIcon":"SortableItem_dragIcon__2_5iI","disabled":"SortableItem_disabled__ohw12"};